<template>
  <el-tabs :ref="`tabsRef${num}`" v-model="values" v-bind="$attrs" :style="{
    '--color': color, '--active-color': activeColor, '--hover-color': hoverColor,'--activeBar':activeBar
  }">
    <template v-for="item in data">
      <el-tab-pane :label="item.文本" :name="item.文本">

      </el-tab-pane>
    </template>
  </el-tabs>
</template>

<script>

export default {
  components: {},
  props: {
    value: {
      type: String,
      default: ''
    },
    data: {type: Array, default: () => []},
    color: {
      type: String,
      default: '#333'
    },
    activeColor: {
      type: String,
      default: '#409eff'
    },
    hoverColor: {
      type: String,
      default: '#409eff'
    },
    activeBar: {
      type: String,
      default:
          '#409eff'
    },
    isHover: {
      type: Boolean,
      default: false
    }
  },
  mixins: [],
  data() {
    return {
      num://随机数
          Math.random().toString(36).substr(2),
      hoverHandlers: [] // 存储事件处理函数的数组
    };
  }
  ,
  computed: {
    values: {
      get() {
        return this.value
      }
      ,
      set(val) {
        this.$emit('input', val)

      }
    }
  }
  ,
  watch: {
    values: {
      handler(val) {
        let data = this.data.find(item => item.文本 === val)
        this.$emit('tab-click', data)
      },
      deep: true
    },
    isHover: {
      handler(val) {
        this.$nextTick(() => {
          this.$refs[`tabsRef${this.num}`].handleTabClick(1, this.data[0].文本);
          this.$refs[`tabsRef${this.num}`].$refs.nav.$nextTick(() => {
            const tabItems = this.$el.getElementsByClassName("el-tabs__item");
            if (val) {
              this.hoverHandlers = Array.from(tabItems).map((item, index) => {
                console.log('this.data[index]', this.data[index], index)
                const handler = () => this.$refs[`tabsRef${this.num}`].handleTabClick(1, this.data[index].文本);
                item.addEventListener("mouseover", handler);
                return handler;
              });
            } else {
              this.hoverHandlers.forEach((handler, index) => {
                tabItems[index].removeEventListener("mouseover", handler);
              });
              this.hoverHandlers = [];
            }
          });
        });
      },
      deep: true,
      immediate: true
    }
  }
  ,
  created() {
  }
  ,
  mounted() {

  }
  ,
  methods: {}
  ,
  beforeDestroy() {
  }
  ,
  destroyed() {
  }
  ,
}

</script>

<style scoped lang="scss">
::v-deep .el-tabs__item {
  color: var(--color) !important;
}

::v-deep .el-tabs__item.is-active {
  color: var(--active-color) !important;
}

::v-deep .el-tabs__item:hover {
  color: var(--hover-color) !important;
}

::v-deep .el-tabs__active-bar {
  background-color: var(--activeBar) !important;
}
</style>

